import React, { useState } from 'react';
import HeaderSite from '../../components/layout/HeaderSite.js';
import Unidades from '../../components/layout/Unidades.js';
import Contact from '../../components/layout/Contact.js';
import Footer from '../../components/layout/Footer.js';
import GoToTop from '../../components/layout/GoToTop.js';
import sweetAlert from '../../components/layout/sweetAlert.js';
import '../../main.css';
import './franqueado.css';

import logoAbfAssociado from '../../imagens/img/logos/ABF_LOGO2023_ASSOCIADO_H_RGB_Final.png';
import CardIcon1 from '../../imagens/img/fotos/icons/handholdingdollar.png';

import { BiDollarCircle } from 'react-icons/bi';
import { LuCalculator } from 'react-icons/lu';

import { abrirPaginas } from '../../components/layout/abrirPaginasFranqueado';
import SendToMake from '../../api/makeApi.js';

//import formatadores from "../../components/import/formatadores";

//import videoYouTube from 'https://www.youtube.com/embed/2ak-JjRkZy8?modestbranding=1'

//APRESENTAÇÃO SLIDES
//--------------------
//import apresentacaoPDF from "../../uploads/Previmune_Apresentacao.pdf#toolbar=0&navpanes=0&scrollbar=0&statusbar=1";
//import apresentacaoPDF from '../../uploads/Previmune_Apresentacao1.pdf';
import apresentacaoPDF from '../../uploads/PREVIMUNE_FRANQUIA_APRESENTACAO_2024.pdf';

import 'bootstrap/dist/css/bootstrap.css';

// function qntMinimaCaracteres(str) {
//   if (str === 'CPF')
//     if (str.length < '14') {
//       document.getElementById('helpCpf').style = 'display: block;';
//       return false;
//     } else {
//       document.getElementById('helpCpf').style = 'display: none;';
//       return true;
//     }
//   else return true;
// }

const Franqueado = () => {
  //const [prazoImplementacao, setPrazoImplementacao] = useState('');
  //const [valorDisponivelInvest, setValorDisponivelInvest] = useState('');
  const [formData, setFormData] = useState({
    nome: '',
    profissao: '',
    cidade: '',
    uf: '',
    celular: '',
    telefone: '',
    email: '',
    prazoImplementacao: '',
    valorDisponivelInvest: '',
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    //console.log('nameDoEvent', name, value);
    if (name === 'prazoImplementacao' || name === 'valorDisponivelInvest') {
      e.target.style.color = 'black';
      if (value === '-1') {
        return
      };
    };

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!verificacoes()) {
      sweetAlert(
        'warning',
        'Atenção',
        'Preencha corretamente as informações ausentes!'
      );
      return;
    }

    try {
      const response = await SendToMake(formData);
      if (response) {
        console.log("Dados enviados com sucesso ao Make.com!", response);
      } else {
        console.log("Falha ao enviar dados ao Make.com!", response);
      }
    } catch (error) {
      console.error("Erro inesperado ao enviar os dados.");
    }

    gotoWhatsapp();
  }

  const verificacoes = () => {
    return (
      formData.prazoImplementacao &&
      formData.prazoImplementacao !== '-1' &&
      formData.valorDisponivelInvest &&
      formData.valorDisponivelInvest !== '-1' &&
      formData.nome !== '' &&
      formData.profissao !== '' &&
      formData.cidade !== '' &&
      formData.uf !== ''
    );
  };

  function gotoWhatsapp() {
    //let number = localStorage.getItem("whats");
    //Numero de Whatsapp para contato: Tela do Franqueado
    const number = '+5535988494588'; //Sandro
    //const number = '+5535991721004'; //Hugo

    const mensagem = `
      FORMULÁRIO DE FRANQUEADO:
      DADOS PESSOAIS
      Nome: ${formData.nome}
      Profissão: ${formData.profissao}
      ------------------------------
      ENDEREÇO
      Cidade: ${formData.cidade}
      UF: ${formData.uf}
      ------------------------------
      CONTATO
      Celular: ${formData.celular}
      Telefone: ${formData.telefone}
      Email: ${formData.email}
      ------------------------------
      INFORMAÇÕES ADICIONAIS
      Prazo para implementação: ${formData.prazoImplementacao}
      Valor disponível para investimento: ${formData.valorDisponivelInvest}
    `;

    const url = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(mensagem)}`;

    //window.open(url, '_blank').focus();
    abrirPaginas(url);
  }

  return (
    <>
      <HeaderSite />
      <section id="formulario" className="section">
        <div className="container">
          <div>
            <div className="section-header">
              <h2
                className="section-title wow fadeIn"
                data-wow-duration="1000ms"
                data-wow-delay="0.3s"
              >
                Conheça a melhor franquia de vacinas do país:
              </h2>
              <hr className="lines wow zoomIn" data-wow-delay="0.3s" />
            </div>

            <br />
            <div className="videoWrapper">
              <iframe
                id="ytplayer"
                type="text/html"
                //width="914"
                //height="514"
                src="https://www.youtube.com/embed/par6sibeuTE?si=QsDBfItNdVYGIBiw"
                title="Seja um franqueado Previmune. A melhor franquia do Brasil."
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            <div className="franqueado-associado">
              <img src={logoAbfAssociado} alt="ABF Associado" />
            </div>
            <div>
              <div
                className="row row-eq-height justify-content-center"
                style={{ textAlign: 'center' }}
              >
                <div
                  className="col-lg-4 mb-4"
                  style={{ backgroundColor: '#e9e9e9' }}
                >
                  <br />
                  <div
                    className="card wow bounceInUp"
                    style={{ backgroundColor: '#e9e9e9' }}
                  >
                    {/* <img src={img1} alt="unidadePassos"></img> */}
                    <div className="card-body">
                      <div className="card-icon">
                        <BiDollarCircle />
                      </div>
                      <h5 className="card-title" style={{ fontSize: '1.3em' }}>
                        <b>Fature até mais de R$ 1 Milhão de Reais por ano</b>
                      </h5>
                      <br />
                    </div>
                  </div>
                  <br />
                </div>

                <div className="col-lg-4 mb-4">
                  <br />
                  <div className="card wow bounceInUp">
                    {/* <img src={img3} alt="unidadePassos"></img> */}
                    <div className="card-body">
                      <div className="card-icon">
                        <LuCalculator />
                      </div>
                      <h5 className="card-title" style={{ fontSize: '1.3em' }}>
                        <b>INVESTIMENTO </b>
                      </h5>
                      <br />
                      <p className="card-text">A partir de R$ 80 mil. </p>
                    </div>
                    <br />
                  </div>
                </div>

                <div
                  className="col-lg-4 mb-4"
                  style={{ backgroundColor: '#e9e9e9' }}
                >
                  <br />
                  <div
                    className="card wow bounceInUp"
                    style={{ backgroundColor: '#e9e9e9' }}
                  >
                    <div className="card-body">
                      <div className="card-icon">
                        <img src={CardIcon1} alt=''></img>
                      </div>
                      <h5 className="card-title" style={{ fontSize: '1.3em' }}>
                        <b>Média de Lucratividade entre 15% e 30%</b>
                      </h5>
                      <br />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div>
              <div
                className="form-group btn-franqueado"
                style={{ paddingTop: '80px' }}
                align="center"
              >
                <h2 style={{ fontSize: '1.8em' }}>
                  Quer ver a nossa apresentação completa?
                </h2>
                <a
                  href={apresentacaoPDF}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: '#e76114',
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  <b>CLIQUE AQUI</b>
                </a>
              </div>
            </div>
          </div>
          <br />
          <div style={{ paddingTop: '80px' }}>
            <div className="section-header">
              <h2
                className="section-title wow fadeIn"
                data-wow-duration="1000ms"
                data-wow-delay="0.3s"
              >
                Formulário Cadastral para Franqueados
              </h2>

              <hr className="lines wow zoomIn" data-wow-delay="0.3s" />

              <p
                className="section-subtitle wow fadeIn"
                data-wow-duration="1000ms"
                data-wow-delay="0.3s"
              >
                Preencha o formulário abaixo e conheça melhor nosso modelo de
                franquias.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <br />
              <br />
              <h3 style={{ width: '100%', textAlign: 'center' }}>
                Dados Pessoais
              </h3>
              <div
                style={{
                  backgroundColor: 'rgb(243, 242, 242)',
                  padding: '20px',
                  borderRadius: '20px',
                  marginLeft: '3%',
                  marginRight: '3%',
                }}
              >
                <div className="form-group">
                  <label htmlFor="txtnome">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    id="txtnome"
                    name='nome'
                    aria-describedby="emailHelp"
                    placeholder="nome completo"
                    onChange={handleFormChange}
                  />
                  <small
                    id="helpNome"
                    className="form-text text-muted"
                    style={{ display: 'none' }}
                  >
                    <p className="text-danger">**Digite o nome completo</p>
                  </small>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-12">
                      <label htmlFor="txtProfissao">Profissão</label>
                      <input
                        type="text"
                        className="form-control"
                        id="txtProfissao"
                        name='profissao'
                        placeholder="profissão"
                        onChange={handleFormChange}
                      />
                    </div>
                  </div>
                </div>{' '}
              </div>

              <br />
              <h3 style={{ width: '100%', textAlign: 'center' }}>Endereço</h3>
              <div
                style={{
                  backgroundColor: 'rgb(243, 242, 242)',
                  padding: '20px',
                  borderRadius: '20px',
                  marginLeft: '3%',
                  marginRight: '3%',
                }}
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="txtCidade">Cidade</label>
                      <input
                        type="text"
                        className="form-control"
                        id="txtCidade"
                        name='cidade'
                        placeholder="nome da cidade"
                        onChange={handleFormChange}
                      />
                      <small
                        id="helpCidade"
                        className="form-text text-muted"
                        style={{ display: 'none' }}
                      >
                        <p className="text-danger">**cidade</p>
                      </small>
                    </div>
                    <div className="col-6">
                      <label htmlFor="txtUf">UF</label>
                      <input
                        type="text"
                        className="form-control"
                        id="txtUf"
                        name='uf'
                        placeholder="uf"
                        onChange={handleFormChange}
                      />
                      <small
                        id="helpUf"
                        className="d-none form-text text-muted"
                      >
                        <p className="text-danger">**uf</p>
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <h3 style={{ width: '100%', textAlign: 'center' }}>Contato</h3>
              <div
                style={{
                  backgroundColor: 'rgb(243, 242, 242)',
                  padding: '20px',
                  borderRadius: '20px',
                  marginLeft: '3%',
                  marginRight: '3%',
                }}
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-12">
                      <label htmlFor="txtCel">Celular</label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength="15"
                        id="txtCel"
                        name='celular'
                        placeholder="(00) 00000-0000"
                        onChange={handleFormChange}
                      />
                      {/*onKeyUp={formataCelular(this,event)} /> */}
                      <small
                        id="helpCel"
                        className="form-text text-muted"
                        style={{ display: 'none' }}
                      >
                        <p className="text-danger">**numero do celular</p>
                      </small>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <label htmlFor="txtTel">Telefone</label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength="14"
                        id="txtTel"
                        name='telefone'
                        placeholder="(00) 00000-0000"
                        onChange={handleFormChange}
                      />{' '}
                      {/*onKeyUp="formataTelefone(this,event);" /> */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <label htmlFor="txtEmail">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="txtEmail"
                        name='email'
                        placeholder="email"
                        onChange={handleFormChange}
                      />
                      <small
                        id="helpEmail"
                        className="form-text text-muted"
                        style={{ display: 'none' }}
                      >
                        <p className="text-danger">**email</p>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <h3 style={{ width: '100%', textAlign: 'center' }}>
                Informações Adicionais
              </h3>
              <div
                style={{
                  backgroundColor: 'rgb(243, 242, 242)',
                  padding: '20px',
                  borderRadius: '20px',
                  marginLeft: '3%',
                  marginRight: '3%',
                }}
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="txtPrazo" style={{ height: '70px' }}>
                        Prazo para implementação
                      </label>

                      <select
                        //onChange={(e) => handleSelectChangePrazo(e)}
                        onChange={handleFormChange}
                        style={{
                          borderRadius: '5px',
                          width: '100%',
                          height: '30px',
                          padding: '2px',
                          color: 'gray',
                        }}
                        id="txtPrazo"
                        name='prazoImplementacao'
                        value={formData.prazoImplementacao}
                      >
                        <option key="-1" value="-1" selected>
                          -- SELECIONE UMA OPÇÃO --
                        </option>
                        <option key="1" value="3 meses">
                          3 meses
                        </option>
                        <option key="2" value="6 meses">
                          6 meses
                        </option>
                        <option key="3" value="12 meses">
                          12 meses
                        </option>
                      </select>
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="txtInvestimento"
                        style={{ height: '70px' }}
                      >
                        Valor disponível para investimento
                      </label>

                      <select
                        //onChange={(e) => handleSelectChangeValor(e)}
                        onChange={handleFormChange}
                        style={{
                          borderRadius: '5px',
                          width: '100%',
                          height: '30px',
                          padding: '2px',
                          color: 'gray',
                        }}
                        id="txtInvestimento"
                        name='valorDisponivelInvest'
                        value={formData.valorDisponivelInvest}
                      >
                        <option key="-1" value="-1">
                          -- SELECIONE UMA OPÇÃO --
                        </option>
                        <option key="1" value="Até 100 mil">
                          Até 100 mil
                        </option>
                        <option key="2" value="De 100 a 150 mil">
                          De 100 a 150 mil
                        </option>
                        <option key="3" value="Acima de 150 mil">
                          Acima de 150 mil
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div className="form-group btn-franqueado" align="center">
                <button
                  //type="button"
                  type='submit'
                  className="btn btn-common"
                //onClick={() => gotoWhatsapp()}
                >
                  Enviar Proposta
                </button>
              </div>
            </form>
          </div>

          <div
            className="form-group btn-franqueado"
            align="center"
            style={{ textAlign: 'center', padding: '10px' }}
          >
          </div>
        </div>
      </section>

      <Unidades />
      <Contact />
      <Footer />
      <GoToTop />
    </>
  );
};

export default Franqueado;
